(function () {
    'use strict';

    angular
        .module('services')
        .service('AuthService', AuthService)

    AuthService.$inject = ['$http', 'API_BASE', '$q', 'jwtHelper', 'AclService', '$state'];

    function AuthService($http, API_BASE, $q, jwtHelper, AclService, $state) {
        var service = this;

        service.isLoggedIn = isLoggedIn;
        service.login = login;
        service.logout = logout;
        service.setToken = setToken;
        service.getRole = getRole;
        service.getCurrentUser = getCurrentUser;
        service.setCurrentUser = setCurrentUser;
        service.currentUser = null;
        service.currentPartnerUser = null;
        service.isLoggedIn = isLoggedIn;
        service.tokenStatus = tokenStatus;
        service.loginPartners = loginPartners;
        service.loginPlatformRental = loginPlatformRental;
        service.loginNewHub = loginNewHub;

        service.isAdmin = isAdmin;
        service.isPartner = isPartner;
        service.isPlatformRental = isPlatformRental;

        function tokenStatus(token) {
            return $http.get(base_url + '/auth/status' + token);
        }

        function isLoggedIn() {
            return localStorage.getItem('id_token') !== null;
        }

        function isAdmin() {
            return localStorage.getItem('fpp_source') === 'admin' && localStorage.getItem('id_token') !== null;
        }

        function isPartner() {
            return localStorage.getItem('fpp_source') === 'partner' && localStorage.getItem('id_token') !== null;
        }

        function isPlatformRental() {
            return localStorage.getItem('fpp_source') === 'platform_rental' && localStorage.getItem('id_token') !== null;
        }

        function getRole() {
            var defer = $q.defer();
            service.getCurrentUser().then(function (user) {
                defer.resolve(user.roles);
            });
            return defer.promise;
        }

        function login(email, password) {
            return $http.post(base_url + '/auth/login', {
                email: email,
                password: password
            }, {
                skipAuthorization: true
            })
            .then(function (response) {
                service.setCurrentUser(response.data.user);
                return service.setToken(response.data.token);
            });
        }

        function logout() {
            var defer = $q.defer();
            var login = localStorage.getItem('fpp_source');
            // TODO: invalidate token server-side
            localStorage.removeItem('id_token');
            localStorage.removeItem('user');
            localStorage.removeItem('AclService');
            localStorage.removeItem('fpp_source'); // For multi tenancy by Vinicius Carvalho

            if (localStorage.getItem('id_token') === null) {
                defer.resolve(null);
            } else {
                defer.reject(localStorage.getItem('id_token'));
            }

            if(login === 'platform_rental') {
                return $state.go('auth.platformRental.login');
            } else if (login === 'partner') {
                return $state.go('auth.partners.login');
            }
            return $state.go('auth.login');
            // return defer.promise;
        }

        function getCurrentUser() {

            var defer = $q.defer();
            service.currentUser = JSON.parse(localStorage.getItem('user'));
            if (service.currentUser)
                defer.resolve(service.currentUser);
            defer.reject(null);
            return defer.promise;
        }

        function setCurrentUser(user) {

            var defer = $q.defer();
            service.currentUser = user;
            localStorage.setItem('fpp_source', user.type);
            localStorage.setItem('user', JSON.stringify(service.currentUser));
            var aclData = {
                user: user.permissions.map(function (permission) {
                    return permission.name;
                }),
            };
            user.roles.map(function (roles) {
                AclService.attachRole(roles.name);
            }),
            AclService.setAbilities(aclData);
            AclService.attachRole('user'); // TODO - know why this to return
            defer.resolve(service.currentUser);
            return defer.promise;
        }

        function setToken(token) {
            var defer = $q.defer();
            if (token !== 'undefined') {
                localStorage.setItem('id_token', token);
                defer.resolve(localStorage.getItem('id_token'));
            } else {
                defer.reject('Token undefined!');
            }
            return defer.promise;
        }

        function loginPartners(email, password) {
            return $http.post(base_url + '/auth/login/partners', {
                    email: email,
                    password: password
                }, {
                    skipAuthorization: true
                })
                .then(function (response) {
                    service.setCurrentUser(response.data.user);
                    return service.setToken(response.data.token);
                });
        }

        function loginPlatformRental(email, password) {
            return $http.post(base_url + '/auth/platform-rental/login', {
                    email: email,
                    password: password
                }, {
                    skipAuthorization: true
                })
                .then(function (response) {
                    service.setCurrentUser(response.data.user);
                    return service.setToken(response.data.token);
                });
        }

        async function loginNewHub(data = {}) {

            return $http.post(base_url + '/api/v1/auth/sso/refresh', data, {
                skipAuthorization: true
            })
        }
    }
})();